module.exports = __webpack_public_path__ + "387b090f082fe0939fc0ca56d0a26bf9.jpg";